import React, { useState } from 'react';
import Modal from '../../../ui_components/Modal/Modal';
import TypeCorrespond from '../../../entities/TypeCorrespond';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@material-ui/core';
import Button from '../../../ui_components/Button/Button';
import ButtonType from '../../../ui_components/Button/ButtonType';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    dialogContent: {
        padding: '24px',
        minWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        backgroundColor: '#ffffff'
    },
    formControl: {
        width: '100%'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '16px'
    }
}));

interface TypeCorrespondSelectionDialogProps {
    open: boolean;
    loading?: boolean;
    onClose: () => void;
    onConfirm: (typeCorrespond: TypeCorrespond) => void;
}

const TypeCorrespondSelectionDialog: React.FC<TypeCorrespondSelectionDialogProps> = ({
    open,
    loading = false,
    onClose,
    onConfirm
}) => {
    const classes = useStyles();
    const [selectedType, setSelectedType] = useState<TypeCorrespond | null>(null);

    const handleConfirm = () => {
        if (selectedType) {
            onConfirm(selectedType);
        }
    };

    const handleClose = () => {
        if (!loading) {
            setSelectedType(null);
            onClose();
        }
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            title="Seleccionar tipo de correspondencia"
            fullScreen={false}
            loading={loading}
        >
            <div className={classes.dialogContent}>
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Tipo de correspondencia</FormLabel>
                    <RadioGroup
                        value={selectedType || ''}
                        onChange={(e) => setSelectedType(e.target.value as TypeCorrespond)}
                    >
                        <FormControlLabel
                            value={TypeCorrespond.CUBANACAN}
                            control={<Radio color="primary" />}
                            label="CUBANACAN"
                            disabled={loading}
                        />
                        <FormControlLabel
                            value={TypeCorrespond.TRANSCARGO}
                            control={<Radio color="primary" />}
                            label="TRANSCARGO"
                            disabled={loading}
                        />
                        <FormControlLabel
                            value={TypeCorrespond.PALCO}
                            control={<Radio color="primary" />}
                            label="PALCO"
                            disabled={loading}
                        />
                        <FormControlLabel
                            value={TypeCorrespond.EMCI}
                            control={<Radio color="primary" />}
                            label="EMCI"
                            disabled={loading}
                        />
                    </RadioGroup>
                </FormControl>

                <div className={classes.buttonContainer}>
                    <Button
                        text="Cancelar"
                        onClick={handleClose}
                        type={ButtonType.DEFAULT}
                        disabled={loading}
                    />
                    <Button
                        text="Confirmar"
                        onClick={handleConfirm}
                        type={ButtonType.PRIMARY}
                        disabled={!selectedType || loading}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default TypeCorrespondSelectionDialog;

